import React, { useEffect, useMemo, useState } from 'react'
import { toTitleCase, isEqualCurrency, ctrlDcmalVal } from '../../../utils/utils';
import { QuestionCircleOutlined, PlusOutlined, MinusOutlined, EditOutlined, } from "@ant-design/icons";
import { invoiceFrequencyOptions } from "../../../utils/Constant";
import { isNumberCheck } from '../../../utils/service/formValidation'
import { Input, Button, message, Form, Modal, Table, Tooltip, Select, } from "antd";
import { getAllISOCodes } from "iso-country-currency";
import SelectComponent from "../../../components/select/SelectComponent";
import ButtonComp from "../../../components/button/ButtonComp";
import CreatableSelect from "react-select/creatable";
import axiosInstance from '../../../utils/axiosInstance';
import { useSelector } from 'react-redux';
import { useTheme } from '../../../utils/themeToggle/theme';

export default function EditProductsTab({ status, editable_user, is_draft, allPduData, handleSave, created_by }) {
  const [allPducs, setAllPducs] = useState([]);
  const [isPudcEdtMod, setIsPudcEdtMod] = useState(false);
  const [edtPduData, setEdtPduData] = useState([]);
  const [isOpnModel, setIsOpnModel] = useState(false);
  const [adPduData, setAdPduData] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [addProductsForm] = Form.useForm();;
  const select = useSelector((state) => state.auth.userInfo);
  const role = select.role;
  const currency = select.currency;
  const compnay_id = localStorage.getItem("companyId") || select.company_id;

  const { reactSelectTheme } = useTheme();

  const handleAddRow = (index, rootData, type) => {
    const clickedProduct = rootData[index];
    const newData = [...rootData];

    const newRow = {
      product_name: clickedProduct.product_name,
      invoice_frequency: null,
      credit_term: null,
      invoice_raising_date: null,
      value: null,
      custom_fields: null,
    };

    newData.splice(index + 1, 0, newRow);
    if (type === 'Add') {
      setAdPduData([...newData]);
      return;
    }
    setEdtPduData([...newData])
  };

  const handleRemoveRow = (index, rootData, type) => {
    const updatedData = [...rootData];
    updatedData.splice(index, 1);

    if (type === 'Add') {
      setAdPduData([...updatedData]);
      return;
    }
    setEdtPduData([...updatedData])

  };

  const countryCurrency = async () => {
    try {
      const codes = await getAllISOCodes();
      const transformedData = codes.map((code) => ({
        value: `${code.symbol}+${code.countryName}`,
        label: `${code.countryName} (${code.symbol})`,
      }));

      setCurrencyOptions([...transformedData]);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  useEffect(() => {
    setEdtPduData([...allPduData])
  }, [allPduData])

  const handleProductEdit = () => {
    setIsPudcEdtMod(true);
  };

  const isEdtBtnShow = useMemo(() => {
    const normalizedRole = role?.toLocaleLowerCase();
    if (allPduData !== 0 &&
      role &&
      (
        (editable_user &&
          status !== "EXECUTED" &&
          status !== "TRANSACTION_CLOSED" &&
          parseInt(select.user_id) === parseInt(editable_user) &&
          (
            ["agreement controller head",
              "professional agreement controller team",
              "professional agreement controller head",
              "professional",
              "agreement controller team"].includes(normalizedRole)
          )
        ) ||
        (is_draft && created_by === select.user_email)
      )
    ) {

      return true
    }

    return false
  }, [status, editable_user, is_draft, created_by])

  const handleCancel = () => {
    setIsPudcEdtMod(false);
    setEdtPduData([...allPduData])
  };

  const handleModalCancel = () => {
    addProductsForm.resetFields();
    setIsPudcEdtMod(false);
    setIsOpnModel(false);
    setAdPduData([])
  }

  const handleProductAdd = () => {
    const newProductList = [...edtPduData, ...adPduData];
    handleSave({ product_list: newProductList });
    handleModalCancel()
  };

  const productOptions = useMemo(() =>
    allPducs.filter((item) => !allPduData?.some((pudc) => pudc.product_name?.toLowerCase() === item.product_name?.toLowerCase()))
      .map((item) => ({
        value: item.product_name, label: toTitleCase(item.product_name),
      }))
    , [allPduData, allPducs])


  const fetchProduct = async () => {
    try {
      const response = await axiosInstance.get(`/company/get_product/?company_id=${compnay_id}`);
      setAllPducs(response.data.data);
    } catch (error) { }
  };

  const addProductHandle = (values) => {
    setSelectedProducts(values);
  };

  const handleProductInputChange = (index, columnName, value) => {
    const newData = [...adPduData];
    newData[index][columnName] = value;
    setAdPduData(newData);
  };

  const addProductColumn = [
    {
      title: "Products / Services",
      width: 90, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <>
          <h1>{record.product_name}</h1>
        </>
      ),
    },

    {
      title: (
        <>
          Invoice Frequency{" "}
          <Tooltip title="One Time/ Monthly/ Quarterly/ Half Yearly  ">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "invoice_frequency",
      width: 120, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <>
          <SelectComponent
            value={
              record.invoice_frequency &&
              invoiceFrequencyOptions.find(
                (freq) => freq.value === record.invoice_frequency
              )
            }
            isClearable
            options={invoiceFrequencyOptions}
            onChange={(selectedOption) =>
              handleProductInputChange(
                index,
                "invoice_frequency",
                selectedOption
              )
            }
            size='small'
            style={reactSelectTheme}
          ></SelectComponent>
        </>
      ),
    },
    {
      title: (
        <>
          Invoice Raising Date{" "}
          <Tooltip title="7th of every succeeding month/ 7th of every month.">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "invoice_raising_date",
      width: 100, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <>
          <Input
            className='text-[15px]'
            value={record.invoice_raising_date}
            onChange={(e) =>
              handleProductInputChange(
                index,
                "invoice_raising_date",
                e.target.value
              )
            }
          />
        </>
      ),
    },
    {
      title: (
        <>
          Credit Term{" "}
          <Tooltip title="Maximum Credit Period Allowed">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "credit_term",
      width: 90, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <Input
          className='text-[12px]'
          value={record.credit_term}
          onChange={(e) =>
            handleProductInputChange(index, "credit_term", e.target.value)
          }
        />
      ),
    }, {
      title: (
        <>
          Contract Currency{" "}
          <Tooltip title="Select the currency of contract.">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "contract_currency",
      width: 140, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => {
        // Extract the default value logic
        const defaultValue = record?.contract_currency
          ? currencyOptions.find((option) => {
            const currencyCode = record.contract_currency.split("+")[1]?.trim().toLowerCase();
            return currencyCode && option.value.toLowerCase() === currencyCode;
          })
          : null;
        return (
          <div className="w-full">
            <Select
              showSearch // Enable search functionality
              style={{ width: "100%", fontSize: "12px" }} // Ensures the dropdown spans full width
              dropdownStyle={{ zIndex: 9999 }} // Keeps the dropdown above other UI elements
              value={defaultValue ? defaultValue.value : undefined} // Set default value dynamically
              options={[...currencyOptions]}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase()) // Enable search based on option label
              }
              onChange={(selectedOption) => {
                if (isEqualCurrency(selectedOption)) {
                  handleProductInputChange(index, "value", record.contract_currency_value);
                  handleProductInputChange(index, "conversion_rate", null);
                }
                handleProductInputChange(index, "contract_currency", selectedOption);
              }}
            />
          </div>
        );
      },
    }

    ,
    {
      title: (
        <>
          Contract Currency Value
          <Tooltip title="Converted currency value.">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "contract_currency_value",
      width: 120,
      ellipsis: true,
      render: (_, record, index) => (
        <Input

          value={record.contract_currency_value || ''}
          className="disabled:bg-transparent text-black text-[12px]"
          onChange={(e) => {
            const inputValue = e.target.value;
            if (isNumberCheck(inputValue)) {
              let contract_currency_value;
              if (isEqualCurrency(record.contract_currency) || !record.conversion_rate) {
                contract_currency_value = inputValue;
              } else {
                contract_currency_value = record.conversion_rate * inputValue;
              }
              handleProductInputChange(index, "contract_currency_value", inputValue);
              handleProductInputChange(index, "value", contract_currency_value);
              if (!inputValue) {
                handleProductInputChange(index, "conversion_rate", null);
              }
              return;
            }
            message.error("Please enter only numerical value.");
          }
          }
        />
      ),
    },
    {
      title: (
        <>
          Conversion Rate{" "}
          <Tooltip title="Enter conversion rate from base currency to contract currency.">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "conversion_rate",
      width: 90, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <Input
          disabled={
            !record.contract_currency_value
            || isEqualCurrency(record.contract_currency)
          }
          className='text-[12px]'
          value={record.conversion_rate || ''}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (isNumberCheck(inputValue)) {
              let contract_currency_value;
              if (!record.contract_currency_value && inputValue) {
                contract_currency_value = inputValue;
              } else if (record.contract_currency_value && !inputValue) {
                contract_currency_value = record.contract_currency_value;
              } else {
                contract_currency_value = record.contract_currency_value * inputValue;
              }
              // Update conversion_rate and value fields
              handleProductInputChange(index, "conversion_rate", inputValue); // Keep original inputValue for precision
              handleProductInputChange(index, "value", contract_currency_value);
              return;
            }
            message.error("Please enter only numerical value.");
          }}
        />
      ),
    },

    {
      title: (
        <>
          Base Currency Value{" "}
          <Tooltip title="Total Contract Value">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "value",
      width: 120, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <Input
          disabled
          value={ctrlDcmalVal(record.value)}
          prefix={<span>{currency}</span>} // Display "India (₹)" as prefix

          className="disabled:bg-transparent text-black text-[10px]"
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 90, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <>
          <Button
            type="primary"
            size='small'
            icon={<PlusOutlined />}
            onClick={() => handleAddRow(index, adPduData, 'Add')}
            style={{ marginRight: 8 }}
          />
          {adPduData.filter((item) => item.product_name === record.product_name)
            .length > 1 && (
              <Button
                size='small'
                type="danger"
                icon={<MinusOutlined />}
                onClick={() => handleRemoveRow(index, adPduData, 'Add')}
              />
            )}
        </>
      ),
    },
  ];

  const onEdtPudcCng = (index, values) => {
    const updatedProductList = [...edtPduData];
    index.forEach((val, ind) => {
      updatedProductList[val] = { ...updatedProductList[val], ...values[ind] };
    })
    setEdtPduData([...updatedProductList])
  };



  const edtProductColumn = useMemo(() => [
    {
      title: "Products / Services",
      width: 80, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <>
          <h1 className='text-[11px]'>{record.product_name || record.custom_product}</h1>
        </>
      ),
    },
    {
      title: (
        <>
          Invoice Frequency{" "}
          <Tooltip title="One Time/ Monthly/ Quarterly/ Half Yearly">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "invoice_frequency",
      width: 90, 
      ellipsis: true, 
      render: (_, record, index) => (
        <>
          {isPudcEdtMod ? (
            <Select
              defaultValue={record.invoice_frequency}
              onChange={(value) =>
                onEdtPudcCng([index], [{ invoice_frequency: value }])

              }
              name="invoice_frequency"
              autoWidth
              optionLabelProp="label"
              className="custom-dropdown w-full"
              style={reactSelectTheme}
            >
              {invoiceFrequencyOptions &&
                invoiceFrequencyOptions.map((inv) => (
                  <Select.Option
                    key={inv.value}
                    value={inv.value}
                    defaultValue={record.invoice_frequency}
                    style={{ fontSize: "12px" }}
                  >
                    {inv.label}
                  </Select.Option>
                ))}
            </Select>
          ) : (
            <h1 className='text-[11px]'>{record.invoice_frequency}</h1>
          )}
        </>
      ),
    },

    {
      title: (
        <div>
          Invoice Raising Date <br />
        </div>
      ),
      dataIndex: "invoice_raising_date",
      key: "invoice_raising_date",
      width: 90, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <>
          {isPudcEdtMod ? (
            <Input
              name={"invoice_raising_date"}
              value={record.invoice_raising_date}
              className='text-[12px]'
              defaultValue={record.invoice_raising_date}
              onChange={(e) =>
                onEdtPudcCng([index], [{ [e.target.name]: e.target.value }])

              }
            />
          ) : (
            <h1 className='text-[12px]'>{record.invoice_raising_date}</h1>
          )}
        </>
      ),
    },
    {
      title: (
        <>
          Credit Term{" "}
          <Tooltip title="Maximum Credit Period Allowed">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "credit_term",
      width: 90, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <>
          {isPudcEdtMod ? (
            <Input
              className='text-[12px]'
              name={"credit_term"}
              value={record.credit_term}
              defaultValue={record.credit_term}
              onChange={(e) =>
                onEdtPudcCng([index], [{ [e.target.name]: e.target.value }])

              }
            />
          ) : (
            <h1 className='text-[12px]'>{record.credit_term}</h1>
          )}
        </>
      ),
    },

    {
      title: (
        <>
          Contract Currency{" "}
          <Tooltip title="Select the currency of contract.">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "contract_currency",
      width: 100, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => {

        return (
          <div className="w-full">
            {isPudcEdtMod ? (
              <Select
                showSearch
                key={`record-${record.contract_currency || index}`}
                style={{ fontSize: "12px", height: "28px", width: "100%" }}  // Selected value text small
                dropdownStyle={{ fontSize: "12px" }}
                className="w-full !h-[28px] !text-[12px]"
                menuPortalTarget={document.body}
                defaultValue={() => {
                  const defaultValue =
                    record?.contract_currency &&
                      !!record.contract_currency
                      ? currencyOptions.find(
                        (option) =>
                          option.value.toLowerCase() ===
                          record.contract_currency?.toLowerCase()
                      )
                      : null;
                  return defaultValue;
                }}
                size='small'
                options={currencyOptions}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase()) // Enable search based on option label
                }
                onChange={(selectedOption) => {
                  if (selectedOption && isEqualCurrency(selectedOption)) {

                    onEdtPudcCng([index], [{ contract_currency: selectedOption, value: record.contract_currency_value, conversion_rate: null }])
                  } else if (selectedOption) {
                    onEdtPudcCng([index], [{ contract_currency: selectedOption }])
                  } else {
                    console.error("Selected option value is undefined");
                  }
                }}
              />
            ) : (
              <h1 className='text-[12px]'>
                {record.contract_currency
                  ? record.contract_currency.split("+")[1]
                  : "No currency"}
              </h1>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <>
          Contract Currency Value {" "}
          <Tooltip title="Converted currency value.">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "contract_currency_value",
      width: 120, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <>
          {isPudcEdtMod ? (
            <Input
              value={record.contract_currency_value || ''}
              className="disabled:bg-transparent text-black"
              onChange={(e) => {
                const inputValue = e.target.value;
                if (isNumberCheck(inputValue)) {
                  let contractCurrencyValue;
                  if (isEqualCurrency(record.contract_currency) || !record.conversion_rate) {
                    contractCurrencyValue = inputValue;
                  } else {
                    contractCurrencyValue = record.conversion_rate * inputValue;
                  }

                  if (!inputValue) {
                    onEdtPudcCng([index], [{ contract_currency_value: inputValue, value: contractCurrencyValue, conversion_rate: null }])
                  } else {
                    onEdtPudcCng([index], [{ contract_currency_value: inputValue, value: contractCurrencyValue }])
                  }
                  return;
                }
                message.error("Please enter only numerical value.");
              }}
              style={{ fontSize: "12px" }}
            />
          ) : (
            <h1 className='text-[12px]'>
              {/* Check if it's an integer */}
              {ctrlDcmalVal(record.contract_currency_value)}
            </h1>
          )}
        </>
      ),
    },

    {
      title: (
        <>
          Conversion Rate{" "}
          <Tooltip title="Enter conversion rate from base currency to contract currency.">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "conversion_rate",
      width: 80, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <>
          {isPudcEdtMod ? (
            <Input
              disabled={
                !record.contract_currency_value
                || isEqualCurrency(record.contract_currency)
              }
              value={record.conversion_rate || ''}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (isNumberCheck(inputValue)) {
                  let contract_currency_value;
                  if (!record.contract_currency_value && inputValue) {
                    contract_currency_value = inputValue;
                  } else if (record.contract_currency_value && !inputValue) {
                    contract_currency_value = record.contract_currency_value;
                  } else {
                    contract_currency_value = record.contract_currency_value * inputValue;
                  }
                  onEdtPudcCng([index], [{ conversion_rate: inputValue, value: contract_currency_value }])
                  return;
                }
                message.error("Please enter only numerical value.");
              }}
              style={{ fontSize: "12px" }}
            />
          ) : (
            // Format conversion_rate to 2 decimal places
            <h1 className='text-[12px]'>{record.conversion_rate}</h1>
          )}
        </>
      ),
    },
    {
      title: (
        <>
          Base Currency Value{" "}
          <Tooltip title="Total Contract Value">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "value",
      width: 120, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <>
          {isPudcEdtMod ? (
            <Input
              name={"value"}
              value={ctrlDcmalVal(record.value)}
              disabled
              defaultValue={record.value}
              prefix={<span>{currency}</span>} // Display "India (₹)" as prefix
              style={{ fontSize: "12px" }}
            />
          ) : (
            <h1 className='!text-[12px]'>
              {/* Remove decimal places and show only integer value */}
              {currency}  {record.value}
            </h1>
          )}
        </>
      ),
    },
    ...(isPudcEdtMod) ? [{
      title: "Action",
      key: "action",
      width: 80, // fixed width
      ellipsis: true, // text overflow me ...
      render: (_, record, index) => (
        <>
          <Button
            type="primary"
            size='small'
            icon={<PlusOutlined />}
            onClick={() => handleAddRow(index, edtPduData, 'Edit')}
            style={{ marginRight: 8 }}
          />
          {edtPduData?.filter((item) => item?.product_name === record?.product_name)
            .length > 1 && (
              <Button
                size='small'
                type="danger"
                icon={<MinusOutlined />}
                onClick={() => handleRemoveRow(index, edtPduData, 'Edit')}
              />
            )}
        </>
      ),
    }] : []
  ], [edtPduData, isPudcEdtMod]);

  useEffect(() => {
    fetchProduct()
    countryCurrency()
  }, [])

  useEffect(() => {
    const newRows =
      selectedProducts &&
      selectedProducts.map((product, index) => {

        const existingRow = adPduData.find(
          (row) => row.product_name === product.label
        );
        return {
          product_name: product.value,
          invoice_frequency: existingRow ? existingRow.invoice_frequency : null,
          credit_term: existingRow ? existingRow.credit_term : null,
          invoice_raising_date: existingRow
            ? existingRow.invoice_raising_date
            : null,
          value: existingRow ? existingRow.value : null,
          custom_fields: existingRow ? existingRow.custom_fields : null,
        };
      });

    setAdPduData(newRows);
  }, [selectedProducts]);

  return (
    <>
      <div className="text-black pb-5 px-2 h-[55px] flex flex-col md:flex-row md:items-center md:justify-between">
        <div className="agreement-details flex items-center justify-between mt-[20px]">
          <h1 className="font-semibold text-[14px]  dark:text-white">
            Products / Services
          </h1>
          {isEdtBtnShow && !isPudcEdtMod && (
            <div className="edit-icon">
              <EditOutlined
                onClick={handleProductEdit}
                className="h-4 ml-2 text-lg transform scale-125 dark:text-white hover:scale-150 transition-transform duration-300 cursor-pointer"
              />
            </div>
          )}
        </div>
        {/* <div className="text-black pb-3 px-2 h-[55px] flex flex-col md:flex-row md:items-center md:justify-between overflow-x-auto"> */}
        <div className="text-black pb-3 px-2 h-[55px] mt-8 flex flex-col md:flex-row md:items-center md:justify-between">
          {isPudcEdtMod ? (
            <div className="flex justify-between">
              <div className="flex">
                <ButtonComp
                  width="7em"
                  text={"Cancel"}
                  onClick={handleCancel}
                  margin={"4px"}
                  textColor="#4E36A3"
                ></ButtonComp>
                <ButtonComp
                  width="7em"
                  type="primary"
                  onClick={() => {
                    handleSave({ product_list: edtPduData })
                    setIsPudcEdtMod(false)
                  }
                  }
                  className=""
                  text={"Save"}
                  textColor="white"
                  bgColor="#4E36A3"
                ></ButtonComp>
              </div>
            </div>
          ) : (
            <>
              {isEdtBtnShow ? (
                <>
                  <button
                    onClick={() => setIsOpnModel(true)}
                    className={`h-12 w-[15rem] rounded-[10px] border border-[#d8bfd8] transition-colors duration-300 -mr-2  !text-purple !hover:text-[#800080] !bg-white`}
                  >
                    <PlusOutlined /> Add More
                  </button>
                </>
              ) : null}
              <Modal
                title="Add Products / Services"
                open={isOpnModel}
                onOk={() => { addProductsForm.submit() }}
                className="product-table-update"
                onCancel={handleModalCancel}
                style={{
                  fontSize: "15px", padding: "20px", // Directly set width of the modal container
                  maxWidth: '95%'
                }} // To ensure responsiveness}}
                centered={true}  // Centers the modal vertically and horizontally
                okText="Save"
                width={600}
                okButtonProps={{
                  style: {
                    backgroundColor: "#4E36A3",
                    color: "white",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Ok button
                cancelButtonProps={{
                  style: {
                    backgroundColor: "",
                    color: "#4E36A3",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Cancel button
              >
                <Form form={addProductsForm} onFinish={handleProductAdd}>
                  <Form.Item label="" name="product_list">
                    <CreatableSelect
                      isMulti
                      options={productOptions}
                      required
                      onChange={addProductHandle}
                    />
                  </Form.Item>
                </Form>
                {selectedProducts.length > 0 ? ( // Render the Table only when there are selected products
                  <div className="product-table">
                    <Table
                      dataSource={adPduData}
                      columns={addProductColumn}
                      pagination={false}
                      bordered
                      className="
                        [&_.ant-table-cell]:!py-[5px]
                        [&_.ant-table-cell]:!text-[10px] 
                        [&_.ant-table-cell]:!p-[5px] 
                        [&_.ant-table-thead_.ant-table-cell]:!text-[10px] 
                        [&_.ant-table-thead_.ant-table-cell]:!p-[5px]"
                      scroll={{ x: "1700" }}
                    />
                  </div>
                ) : (
                  ""
                )}
              </Modal>

            </>
          )}

        </div>
      </div>
      <Table
        dataSource={edtPduData}
        columns={edtProductColumn}
        pagination={false}
        bordered
        className="
          [&_.ant-table-cell]:!py-[5px]
          [&_.ant-table-cell]:!text-[9px] 
          [&_.ant-table-cell]:!p-[5px] 
          [&_.ant-table-thead_.ant-table-cell]:!text-[9.8px] 
          [&_.ant-table-thead_.ant-table-cell]:!p-[5px]"
        scroll={{ x: "1800" }}
      />
    </>
  )
}
